import script from "./BannerTempOne.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerTempOne.vue?vue&type=script&setup=true&lang=js"

import "./BannerTempOne.vue?vue&type=style&index=0&id=57e571b5&lang=scss&scoped=true"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57e571b5"]])

export default __exports__